// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"27":"BuyerLazyComponent","46":"BadgeTooltipV1","795":"IntroVideoModal"}[chunkId] + "." + {"27":"ce967fc78606fc8c5c76","46":"bcfa3871b07f9445876f","795":"3187f4047e5c8023c709"}[chunkId] + ".js";
};